import { useMemo } from 'react';
import { IconChecked } from '../../../../icon/IconChecked';
import { IconChevron } from '../../../../icon/IconChevron';
import { Button } from '../../../../input/Button';
import { Menu, MenuItem } from '../../../../navigation/Menu';
import { Typography } from '../../../../typography/Typography';
import { FeedManagementDropdownProps } from './types';

export function FeedManagementDropdown<TValue>(props: FeedManagementDropdownProps<TValue>) {
    const { placeholder, value, options, additionalOption, onChange } = props;
    const selectedOption = options.find((option) => option.value === value);
    const menuItems = useMemo(() => {
        const items = options.map((option) => (
            <MenuItem
                key={option.displayName}
                spacing={1}
                direction="row"
                justifyContent="space-between"
                onClick={() => onChange(value === option.value ? null : option.value)}
            >
                <Typography variant="body" noWrap>
                    {option.displayName}
                </Typography>
                <IconChecked
                    size={20}
                    color={value === option.value ? 'var(--color-primary)' : 'transparent'}
                />
            </MenuItem>
        ));

        if (additionalOption) {
            items.push(additionalOption);
        }

        return items;
    }, [onChange, options, value, additionalOption]);

    return (
        <Menu
            trigger={
                <Button spacing={0.25} size="s" variant="filled" color="secondary">
                    <Typography variant="caption" weight="bold" letterSpacing="0.7px" noWrap>
                        {selectedOption?.displayName ?? placeholder}
                    </Typography>
                    <IconChevron size={20} />
                </Button>
            }
        >
            {menuItems}
        </Menu>
    );
}
